import { RESET_STATE, SET } from "@/stores/CommumActionTypes";
import {
	SET_SELECTED_FREQUENCY_TREND_SIGNAL,
	SET_LOADING_FREQUENCY_TREND_SIGNAL,
	SET_AVAILABLE_FREQUENCY_TREND_SIGNAL,
	SET_MENU_OPENED,
	TOGGLE_COMMON_GROUP_EXPANDED,
	TOGGLE_DISTINCT_GROUP_EXPANDED,
	ON_TOGGLE_DISTINCT_ASSET_GROUP,
	SET_DISTINCT_ASSET_GROUP,
	SET_SHOW_SIGNAL_NAME_DIALOG,
	SET_AVAILABLE_SIGNALS,
	CLEAR_AVAILABLE_SIGNALS,
	SET_COMMON_GROUP_EXPANDED,
	SET_DISTINCT_GROUP_EXPANDED,
	SET_FILTER_TEXT,
	SET_NO_DATA_AVAILABLE,
	CLEAR_SELECTED_FREQUENCY_TREND_SIGNALS
} from "./FrequencyTrendSignalActionsType";

const mutations = {
	/**
	 * Armazena os settings completos retornados pela API por ativo.
	 */
	[SET]: (state, assets) =>
	{
		state.assetsFrequencyTrendSettings = assets;
	},

	/**
	 * Armazena os sinais selecionados (processados).
	 */
	[SET_SELECTED_FREQUENCY_TREND_SIGNAL]: (state, assets) =>
	{
		state.selectedFrequencyTrendSettings = assets || [];
	},

	/**
	 * Ativa ou desativa o loading da busca de sinais.
	 */
	[SET_LOADING_FREQUENCY_TREND_SIGNAL]: (state, isLoading) =>
	{
		state.isFrequencyTrendSignalSettingsLoading = isLoading;
	},

	/**
	 * Armazena os sinais disponíveis para o autocomplete.
	 */
	[SET_AVAILABLE_FREQUENCY_TREND_SIGNAL](state, assets)
	{
		state.assetsFrequencyTrendSettings = assets;

		state.availableCommonSignals = assets[0]?.commonSignals || [];

		const groupedDistinctSignals = [];

		assets.forEach(assetSignals =>
		{
			if (!assetSignals.distinctSignals || assetSignals.distinctSignals.length === 0)
			{
				return;
			}

			const assetName = assetSignals.name;

			groupedDistinctSignals.push({
				assetName,
				signals: assetSignals.distinctSignals.map(signal => ({
					...signal,
					assetName,
				})),
			});
		});

		state.availableDistinctSignalGroups = groupedDistinctSignals;
		
		const allAssetNames = groupedDistinctSignals.map(group => group.assetName);
		state.expandedDistinctAssetGroups = allAssetNames;
	},

	/**
	 * Reseta o estado dos sinais selecionados.
	 */
	[RESET_STATE]: (state) =>
	{
		state.selectedFrequencyTrendSettings = [];
		state.availableFrequencyTrendSignalSettings = [];
		state.isFrequencyTrendSignalSettingsLoading = false;
		state.availableCommonSignals = [];
		state.availableDistinctSignalGroups = [];
		state.expandedDistinctAssetGroups = [];
	},
	[SET_MENU_OPENED]: (state, isOpen) =>
	{
		state.menuOpened = isOpen;
	},
	
	[SET_AVAILABLE_SIGNALS]: (state, { commonSignals, distinctSignalGroups }) =>
	{
		state.availableCommonSignals = commonSignals || [];
		state.availableDistinctSignalGroups = distinctSignalGroups || [];
	},
	
	[CLEAR_AVAILABLE_SIGNALS]: (state) =>
	{
		state.availableCommonSignals = [];
		state.availableDistinctSignalGroups = [];
	},
	
	[SET_COMMON_GROUP_EXPANDED]: (state, value) =>
	{
		state.CommonGroupExpanded = value;
	},
	
	[SET_DISTINCT_GROUP_EXPANDED]: (state, value) =>
	{
		state.DistinctGroupExpanded = value;
	},
	
	[TOGGLE_COMMON_GROUP_EXPANDED]: (state) =>
	{
		state.CommonGroupExpanded = !state.CommonGroupExpanded;
	},
	
	[TOGGLE_DISTINCT_GROUP_EXPANDED]: (state) =>
	{
		state.DistinctGroupExpanded = !state.DistinctGroupExpanded;
	},
	
	[ON_TOGGLE_DISTINCT_ASSET_GROUP]: (state, assetName) =>
	{
		const index = state.expandedDistinctAssetGroups.indexOf(assetName);
		if (index > -1)
		{
			state.expandedDistinctAssetGroups.splice(index, 1);
		}
		else
		{
			state.expandedDistinctAssetGroups.push(assetName);
		}
	},
	
	[SET_DISTINCT_ASSET_GROUP]: (state, assetName) =>
	{
		state.expandedDistinctAssetGroups = assetName ? [ assetName ] : [];
	},
	[SET_SHOW_SIGNAL_NAME_DIALOG](state, value)
	{
		state.ShowSignalNameDialog = value;
	},
	[SET_MENU_OPENED]: (state, isOpen) =>
	{
		state.menuOpened = isOpen;
	},
	[SET_FILTER_TEXT]: (state, text) =>
	{
		state.filterText = text;
	},
	[SET_NO_DATA_AVAILABLE]: (state, value) =>
	{
		state.noDataAvailable = value;
	},
	[CLEAR_SELECTED_FREQUENCY_TREND_SIGNALS]: (state) =>
	{
		state.selectedFrequencyTrendSettings = [];
	},
};

export default { mutations };
